import { useEffect, useRef } from "react";

export function useReveal(enabled = true) {
  const ref = useRef(null);
  useEffect(() => {
    if (!enabled) return;
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    const nodes = el.querySelectorAll(".reveal, .reveal-blur");
    nodes.forEach((n) => io.observe(n));
    // Fallback: anything already in viewport — reveal immediately
    requestAnimationFrame(() => {
      nodes.forEach((n) => {
        const r = n.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          n.classList.add("in");
        }
      });
    });
    return () => io.disconnect();
  }, [enabled]);
  return ref;
}
